import erpSoftware from "../images/service/erpsoftware.jpg";
import vehicleTracking from "../images/service/vehicletracking.jpg";
import inventory from "../images/service/inventory.jpg";
import javascript from "../images/service/javascript.png";
import backend from "../images/service/backend.png"
import logistic from "../images/service/logistics.webp";
import fleet from "../images/service/fleet-manage.jpg";
import fleetman from "../images/service/fleetman.png";
import rental from "../images/service/rental.png";
import rentman from "../images/service/rentman.png";
import vehicleImg from "../images/service/vehicle.jpg";
import vehtrack from "../images/service/vehtrack.jpg";

import tel1 from "../images/teltonika/teltonika-fm1202-waterproof-gps-1.jpg";
import tel2 from "../images/teltonika/teltonika-fmc130-2.png";
import tel3 from "../images/teltonika/teltonika-fmu130-3.png";
import tel4 from "../images/teltonika/teltonika-fmu-125-4.png";
import tel5 from "../images/teltonika/screenshot-81-5.png";
import tel6 from "../images/teltonika/fmb204-ip67-and-li-ion-back-up-battery-6.png";
import tel7 from "../images/teltonika/teltonika-fm5500-7.jpg";
import tel8 from "../images/teltonika/gps-vehicle-tracking-devices-teltonika-fm1120-8.png";
import tel9 from "../images/teltonika/teltonika-fm5300-rs232-can-bus-extended-ios-gps-9.png";
import tel10 from "../images/teltonika/teltonika-fmb920-10.png";
import tel11 from "../images/teltonika/fm1000-st-11.jpg";
import tel12 from "../images/teltonika/teltonika-fmb900-micro-sd-card-and-bluetooth-v3-0-12.jpg";
import tel13 from "../images/teltonika/fm1125-rs232-rs485-13.jpg";
import tel14 from "../images/teltonika/fm1010-obd-ii-tracker-14.jpg";

import gt1 from "../images/gt800/gt800-vehicle-tracker-1.png";
import gt2 from "../images/gt800/personal-gps-tracker-2.jpg";

import wetrack1 from "../images/wetrack/wetrack2-1.png";
import wetrack2 from "../images/wetrack/garmin-gpsmap-64s-2.jpg";
import wetrack3 from "../images/wetrack/gps-navigation-device-3.jpg";
import wetrack4 from "../images/wetrack/garmin-etrex-20x-4.jpg";

import at1 from "../images/at4/product-1.jpeg";
import at2 from "../images/at4/bu3563-global-sat-2.jpg";

import d1 from "../images/3d/prusa-1.jpg";
import d2 from "../images/3d/3d-2.jpg";
import d3 from "../images/3d/pla-filaments-3.jpg";
import d4 from "../images/3d/mkum3_ultimaker_quarter_800x800_compact-4.jpg";

import v5concox from "../images/teltonika/v5concox.jpeg";
import app from "../images/app.png";

import vehicle from "../images/service/transport/46986.gif";
import vehicleChecklist from "../images/service/transport/driver-image.jpg";
import vehicleinfo from "../images/service/transport/driver.webp";
import pdfs from "../images/driver-and-vehicle-checklist.pdf";

// driver ins
import driver from "../images/service/transport/driver.webp";
import driverChecklist from "../images/service/transport/70226.gif";
import driverinfo from "../images/service/transport/driver-checklist.jpg";

import transportlog from "../images/service/transport/main.jpg";

export const servicelist = [
  {
    id: 1,
    name: "Digital Vehicle Inspection Checklist Mobile App",
    featured: true,
    home: true,
    websitType: "Mobile Application",
    file: pdfs,
    image01: vehicle,
    detailImg: vehicleChecklist,
    infoImg: vehicleinfo,
    description:
      "Vehicle checklist is specifically designed for Trucks and Cars checklist with 30-35 questions. This mobile application is helpful for Trucking fleet management and warehouses. Who are using multi level trucking checklist before loading the trucks",
    features: [
      "Minimum order quantity: 1 unit",
      "Brand: Web based",
      "Development Platforms: Android",
      "Technology: Web,Android and iOS mobile app in English and Hindi Language",
      "Service type: Truck and Cars checklist Android application",
      "Service mode: Offline and Online",
      "Service Available: Immediate",
      "Type: Android mobile application",
      "Usage/Application: Mobile Application",
    ],
  },
  {
    id: 2,
    name: "Digital Driver Inspection Checklist Mobile App",
    home: true,
    featured: true,
    websitType: "Mobile Application",
    file: pdfs,
    image01: driver,
    detailImg: driverChecklist,
    infoImg: driverinfo,
    description:
      "A digital vehicle & driver inspection checklist is a modern tool that enhances vehicle safety and compliance by enabling drivers to conduct thorough inspections electronically. It replaces traditional paper-based processes with efficient, digital workflows that ensure all required inspection points are covered. These checklists typically include items such as brakes, lights, tires, and fluid levels, helping to maintain fleet integrity and regulatory adherence while streamlining reporting and maintenance processes for transportation companies.",
    features: [
      "Minimum order quantity: 1 unit",
      "Brand: Web based",
      "Development Platforms: Android",
      "Technology: Web,Android and iOS mobile app in English and Hindi Language",
      "Service type: Truck and Cars checklist Android application",
      "Service mode: Offline and Online",
      "Service Available: Immediate",
      "Type: Android mobile application",
      "Usage/Application: Mobile Application",
    ],
  },
  {
    id: 3,
    name: "Transport Management System Software",
    home: true,
    featured: false,
    websitType: "Mobile Application",
    file: pdfs,
    image01: transportlog,
    detailImg: vehicleChecklist,
    infoImg: vehicleinfo,
    description:
      "Transport Management System Software optimizes logistics operations, enhancing efficiency and transparency in fleet management, routing, scheduling, and resource allocation.",
    features: [
      "Own vehicle",
      "Hire/Lease Vehicle",
      "Vehicle documents scanned copy upload",
      "Vehicle related SMS and Email (Insurance, Service, Road permit, Pollution)",
      "Battery Management & Maintenance",
      "Tyre Maintenance",
      "aily progress for hired and own vehicles",
      "trip management",
      "fuel management",
      "toll management",
      "misc charges",
      "Opening & Closing KM",
      "Extra Hours Work Management",
      "Hired Vehicles Commission/Brokerage Management",
      "Maintenance Management with or without Trip ",
      "Tax Invoice Generation",
      "Single or Multiple Trips",
      "Single or Multiple Builty/LR ",
      "Challan Linked with Builties",
      "Proof of Delivery",
    ],
    info: [
      "Builty Status Reports",
      "Challan Reports",
      "Trip Management Reports",
      "Maintenance Reports",
      "Profit/Loss Reports",
      "Alerts for Periodic Maintenance",
      "Own Vehicles transfer between Branches",
      "Vehicle Status Report",
      "Vehicle Maintenance Book",
      "Fuel Consumption",
      "Route Management",
      "Vehicle Costing Profit/Loss Report",
      "License Type",
      "Police Verification Details",
      "Driver Picture Upload",
      "All documents related to driver (e.g License)",
      "License expiry details",
      "Driver comparison report for same or different Routes",
      "Driver Performance Report",
      "GST Certificate",
      "Vendor Photo",
      "Address document",
      "Route Management etc.",
      "Multiple Branch Management",
    ],
  },
  {
    id: 4,
    name: "Logistics Management System Software",
    home: true,
    featured: false,
    websitType: "Mobile Application",
    file: pdfs,
    image01: logistic,
    detailImg: vehicleChecklist,
    infoImg: vehicleinfo,
    description:
      "Logistics management System software streamlines operations, facilitating efficient planning, tracking, and optimization of supply chain activities for enhanced productivity and cost-effectiveness.",
    features: [
      "Own vehicle",
      "Hire/Lease Vehicle",
      "Vehicle documents scanned copy upload",
      "Vehicle related SMS and Email (Insurance, Service, Road permit, Pollution)",
      "Battery Management & Maintenance",
      "Tyre Maintenance",
      "aily progress for hired and own vehicles",
      "trip management",
      "fuel management",
      "toll management",
      "misc charges",
      "Opening & Closing KM",
      "Extra Hours Work Management",
      "Hired Vehicles Commission/Brokerage Management",
      "Maintenance Management with or without Trip ",
      "Tax Invoice Generation",
      "Single or Multiple Trips",
      "Single or Multiple Builty/LR ",
      "Challan Linked with Builties",
      "Proof of Delivery",
    ],
    info: [
      "Builty Status Reports",
      "Challan Reports",
      "Trip Management Reports",
      "Maintenance Reports",
      "Profit/Loss Reports",
      "Alerts for Periodic Maintenance",
      "Own Vehicles transfer between Branches",
      "Vehicle Status Report",
      "Vehicle Maintenance Book",
      "Fuel Consumption",
      "Route Management",
      "Vehicle Costing Profit/Loss Report",
      "License Type",
      "Police Verification Details",
      "Driver Picture Upload",
      "All documents related to driver (e.g License)",
      "License expiry details",
      "Driver comparison report for same or different Routes",
      "Driver Performance Report",
      "GST Certificate",
      "Vendor Photo",
      "Address document",
      "Route Management etc.",
      "Multiple Branch Management",
    ],
  },
  {
    id: 5,
    name: "Fleet Management System Software",
    home: true,
    featured: false,
    websitType: "Mobile Application",
    file: pdfs,
    image01: fleet,
    detailImg: fleetman,
    // infoImg: vehicleinfo,
    description:
      "Fleet management System software enables efficient management of vehicles, including tracking, maintenance scheduling, driver management, and route optimization for streamlined operations.",
    features: [
      "Own vehicle",
      "Hire/Lease Vehicle",
      "Vehicle documents scanned copy upload",
      "Vehicle related SMS and Email (Insurance, Service, Road permit, Pollution)",
      "Battery Management & Maintenance",
      "Tyre Maintenance",
      "aily progress for hired and own vehicles",
      "trip management",
      "fuel management",
      "toll management",
      "misc charges",
      "Opening & Closing KM",
      "Extra Hours Work Management",
      "Hired Vehicles Commission/Brokerage Management",
      "Maintenance Management with or without Trip ",
      "Tax Invoice Generation",
      "Single or Multiple Trips",
      "Single or Multiple Builty/LR ",
      "Challan Linked with Builties",
      "Proof of Delivery",
    ],
    // info: [
    //   "Builty Status Reports",
    //   "Challan Reports",
    //   "Trip Management Reports",
    //   "Maintenance Reports",
    //   "Profit/Loss Reports",
    //   "Alerts for Periodic Maintenance",
    //   "Own Vehicles transfer between Branches",
    //   "Vehicle Status Report",
    //   "Vehicle Maintenance Book",
    //   "Fuel Consumption",
    //   "Route Management",
    //   "Vehicle Costing Profit/Loss Report",
    //   "License Type",
    //   "Police Verification Details",
    //   "Driver Picture Upload",
    //   "All documents related to driver (e.g License)",
    //   "License expiry details",
    //   "Driver comparison report for same or different Routes",
    //   "Driver Performance Report",
    //   "GST Certificate",
    //   "Vendor Photo",
    //   "Address document",
    //   "Route Management etc.",
    //   "Multiple Branch Management",
    // ],
  },
  // {
  //   id: 4,
  //   name: "E-Commerce Development Service",
  //   featured: false,
  //   minimumOrderQuantity: "1 Unit",
  //   websitType: "software development",
  //   features: [
  //     "Payment gateways: All types of payment gateways",
  //     "Unlimited Categories and Products",
  //     "Two products variation families",
  //     "Unlimited offer discounts either all categories or specific product lines.",
  //     "Before and after sales price",
  //     "Facebook comments on products",
  //     "Post products directly to Twitter and Facebook",
  //     "Ratings and comments on products",
  //     "Manual and automatic stock control",
  //     "Internal products notes and cost pricing",
  //     "Customer account areas: Customers log in and admin their own account area",
  //     "Customer account area order history: Customers can pre-order directly from their previous order history.",
  //     "Customer order purchase tracking: Let your customer know at what stage their order is at, from received to packed to dispatched and more.",
  //     "Automatic postage add-on: let the site add up your weight and calculate your postage automatically.",
  //     "International delivery: make sure international orders pay the right postage automatically.",
  //     "Wishlist's: store your order for the future",
  //     "Wholesale option: let your distributors create an order and email it directly to you.",
  //     "Get your business up and running 24/7 and generate sales even when you are sleeping.",
  //   ],
  //   additionalInfo: "something",
  //   deliveryTime: "1 Month",
  //   featured: false,
  //   image01: ecommerce,
  //   image02: androidDevelopment,
  //   description:
  //     "Comprehending the ghettoized requirements of our regulars, we are willingly immersed in offering highly reliable School ERP Software Development. Oghettoized requirements of our regulars, ",
  // },

  {
    id: 6,
    name: "ERP Software Services",
    minimumOrderQuantity: "1 Unit",
    home: true,
    featured: false,
    websitType: "software development",
    features: [],
    additionalInfo: "Pay Mode Terms: T/T (Bank Transfer)",
    deliveryTime: "depends upon the client requirement",
    featured: false,
    image01: erpSoftware,
    image02: erpSoftware,
    description:
      "Our organization has created niche in offering Manufacturing, Logistics,Transporters ERP Software Services to our clients. Experts are offering user-friendly ERP software for this purpose. The software and web application offered by expert’s works in excellent manner. These Manufacturing ERP Software Services are highly acclaimed and have been able to gain huge customer support.",
  },
  {
    id: 7,
    name: "Vehicle Tracking Software Solution",
    featured: false,
    minimumOrderQuantity: "1 Unit",
    websitType: "software development",
    features: [
      "Where are my vehicles",
      "What was the route taken by the vehicle",
      "How much was the distance traveled",
      "How many trips made",
      "How is vehicle usage (hours driven each day)   Efficiency:",
      "Stoppages are optimum or at designated points",
      "Vehicle turn-around times are optimum",
      "Fuel consumption",
      "Violation of pre-defined route",
      "Special conditions for cargo en-route is being met (Temperature) Safety",
      "Dangerous driving",
      "Drivers taking adequate rest en-route",
      "Vehicles being driven only during allowed times",
    ],
    additionalInfo: "Pay Mode Terms: T/T (Bank Transfer)",
    deliveryTime: "depends upon the client requirement",
    featured: false,
    image01: vehicleTracking,
    infoImg: vehicleTracking,
    description:
      "Being one of the best organizations, we are offering Vehicle Tracking Software Service. Under this service, vehicle tracking software is developed by our skilled professionals using the most advanced technology. The software developed provides information about the location of vehicles, route taken by the vehicle, distance travelled by vehicles, etc. We offer this service as per the requirements of our clients. Further, the offered service is highly demanded by our clients for its cost-effectiveness and reliability.",
  },
  {
    id: 8,
    name: "Warehouse & Inventory Management System Software",
    websitType: "software development",
    featured: false,
    image01: inventory,
    image02: inventory,
    detailImg: inventory,
    description:
      "Wholesale Trader of a wide range of products which include warehouse management software and warehouse management system.",
    features: [
      "Minimum Order Quantity: 1 unit",
      "Application: warehouse management software",
      "Software version: 1.1",
    ],
  },
  {
    id: 9,
    name: "Proof of Delivery by wheels on Map",
    featured: false,
    websitType: "Mobile Application",
    file: pdfs,
    image01: app,
    detailImg: vehicleChecklist,
    infoImg: vehicleinfo,
    description:
      "WOMSolutions provide Proof of delivery by Android and iOS app, also introduce as a ePOD driver mobile app that creates evidence of goods delivery on time with customers signature, invoice image and geo-location. ePOD eliminates the paperwork and ensure by the customer to get successful delivery. Not only this by using ePOD we can plan our delivery, because the moment driver delivers the goods it sends sms and email message to customer and head office and we can again plan for delivery to new routes. ePOD mobile app saves time and costs of delivery.",
  },
  {
    id: 10,
    name: "Latest Technologies we worked On",
    featured: false,
    websitType: "Software development",
    file: pdfs,
    image01: javascript,
    detailImg: javascript,
    infoImg: backend,
    description:
      "JavaScript (JS) is the most popular lightweight, interpreted compiled programming language. It can be used for both Client-side as well as Server-side developments. JavaScript also known as a scripting language for web pages.",
    features: [
      "React offers various extensions for entire application architectural support, such as Flux and React Native, beyond mere UI.",
      "Storm by offering a way to develop mobile apps for both iOS and Android simultaneously (React Native)",
      "Angular JS is an open source JavaScript framework by Google to build web applications. It can be freely used, changed and shared by anyone, It's work on MVC Pattern",
    ],
    info: [
      "Node.js is a cross-platform, open-source server environment that can run on Windows, Linux, Unix, macOS, and more. Node.js is a back-end JavaScript runtime environment.",
      "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
      "MongoDB is an open source NoSQL database, MongoDB is used for high-volume data storage, helping organizations store large amounts of data while still performing rapidly.",
    ],
  },
  {
    id: 11,
    name: "AMC & Rental Management Software",
    featured: false,
    websitType: "Software development",
    file: pdfs,
    image01: rental,
    detailImg: rentman,
    // infoImg: backend,
    description:
      "AMC & Rental management software from WOM Solutions provides a streamlined solution for overseeing rental properties. Designed specifically for AMCs, this software enhances operational efficiency and tenant management without sacrificing quality.",
    features: [
      "Tenant Management",
      "Lease Administration",
      "Maintenance Tracking",
      "Financial Oversight",
      "Efficiency in Rent Collection",
      "Document Management",
      "Efficiency in Rent Collection",
      "Property Management",
      "Maintenance Scheduling",
      "Report and Analytics"
    ],
    // info: [
    //   "Node.js is a cross-platform, open-source server environment that can run on Windows, Linux, Unix, macOS, and more. Node.js is a back-end JavaScript runtime environment.",
    //   "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    //   "MongoDB is an open source NoSQL database, MongoDB is used for high-volume data storage, helping organizations store large amounts of data while still performing rapidly.",
    // ],
  },
  {
    id: 12,
    name: "Vehicle Tracking Software Solution",
    featured: false,
    websitType: "Software development",
    file: pdfs,
    image01: vehicleImg,
    detailImg: vehtrack,
    // infoImg: backend,
    description:
      "A vehicle tracking software solution enables real-time monitoring and management of fleets and assets. It uses GPS technology to track vehicle locations, routes, and speeds, providing valuable data for optimizing operations, improving efficiency, and ensuring security. This software typically offers features such as geofencing, route optimization, maintenance scheduling, and driver behavior monitoring. It is crucial for businesses to enhance fleet management, reduce operational costs, and improve customer service by accurately tracking vehicles and assets on the move.",
    features: [
      "Where are my vehicles",
      "What was the route taken by the vehicle",
      "What was the route taken by the vehicle",
      "How many trips made",
      "How is vehicle usage (hours driven each day) Efficiency:",
      "Stoppages are optimum or at designated points",
      "Vehicle turn-around times are optimum",
      "Fuel consumption",
      "Violation of pre-defined route",
      "Special conditions for cargo en-route is being met (Temperature) Safety",
      "Dangerous driving",
      "Drivers taking adequate rest en-route",
      "Vehicles being driven only during allowed times",
    ],
    // info: [
    //   "Node.js is a cross-platform, open-source server environment that can run on Windows, Linux, Unix, macOS, and more. Node.js is a back-end JavaScript runtime environment.",
    //   "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    //   "MongoDB is an open source NoSQL database, MongoDB is used for high-volume data storage, helping organizations store large amounts of data while still performing rapidly.",
    // ],
  },
];

export const category = [
  {
    display: "Software Development",
    categorySlug: "software-development",
  },
  {
    display: "Android Application Development",
    categorySlug: "android-application-development",
  },
  {
    display: "Transport Management System",
    categorySlug: "transport-management-system",
  },
  {
    display: "GPS vehicle Tracking Device",
    categorySlug: "gps-vehicle-tracking-device",
  },
  {
    display: "Website Development",
    categorySlug: "website-development",
  },
  {
    display: "Our Products",
    categorySlug: "our-products",
  },
  {
    display: "3D Printers",
    categorySlug: "3d-printers",
  },
  {
    display: "Logistic Management",
    categorySlug: "logistic-management",
  },
];

export const productlist = [
  // {
  //   id: 1,
  //   name: "Prusa I3 3D Printer Diy Kit",
  //   websitType: "printer",
  //   image01: d1,
  //   description:
  //     "2015 Upgraded Quality High Precision Reprap Prusa i3 DIY 3d Printer kit with 2 Rolls Filament 8GB SD card and LCD for Free",
  //   features: ["Minimum order quantity One unit", "Usage personal"],
  // },
  // {
  //   id: 2,
  //   name: "3D Printer",
  //   websitType: "printer",
  //   image01: d2,
  //   description:
  //     "As we all know, we are stepping into 3D world, and 3D technology is gradually changing our life and the way of production. This new version 3D printer takes the leading in globle area using 57 stepper motor, providing higher speed and stable performance compared with printers using 42 stepper motor. With high precision 32 subdivision mainboard, this printer machine makes less noise and works with much higher accuracy. The accuracy of XY/Z axises are seperately up to 1.0um and 1.5um, making it an ideal choice even for refined industrial products. It is compatible with both ABS and PLA material, and the max print evelop is up to 300x200x360MM. It is absolutely a perfect assistant for industrial model making.",
  //   features: [
  //     "Advance Configuration",
  //     "Higher performance",
  //     "Dual CPU + 32 subdivision motherboard + 57 stepper motor",
  //     "Balance connecting rod structure + Full stainless steel structure",
  //     "Large Build size 300*200*360mm + 0.04mm layer thickness + Fast speed",
  //   ],
  //   info: [
  //     "More rapid: Fire-new XY structure, 20% speed and 30% accuracy increase",
  //     "More human: Multi language, Dual CPU motherboard, digital current control",
  //     "Refined: Stainless steel, Laser cutting seamless welding",
  //   ],
  // },
  {
    id: 3,
    name: "At4 Asset Tracker Personal GPS Car, Truck GPS Tracker Magnetic",
    websitType: "gps",
    image01: at1,
    description: "It's a magnetic GPS Tracker with 10-15 days backup.",
    features: [
      "Minimum order quantity: 10 box",
      "Available Accessories: charger",
      "Usage/Application: any",
      "Mobile Supported: yes",
      "Vehicle type: any",
      "Tracking technique: mobile app",
      "model number: AT4",
      "touch screen: no",
      "brand: concox",
      "type: wireless",
    ],
  },
  {
    id: 4,
    name: "3D Printing PLA-ABS Filaments",
    websitType: "3D printer",
    image01: d3,
    description:
      "Shape your dreams with 3D PLA/ABS 1.75(2000) & 3mm(1500 rs.) Filaments. It will be in good quality 3D printing.",
    features: [
      "Material: polylactic acid, ABS",
      "brand: multiple",
      "color: natural,multicolor,red,blue",
      "size: 1.74mm",
    ],
  },
  // {
  //   id: 5,
  //   name: "Ultimaker 2 3D Printer",
  //   websitType: "3D printer",
  //   image01: d4,
  //   description:
  //     "When the editors at Make: tested the original Ultimaker in our first annual Ultimate Guide to 3D Printing, we were impressed with the machine's speed and resolution. When we tested the Ultimaker 2 in our 2nd Ultimate Guide, we were even more impressed.<br />The Ultimaker 2 was created to be as easy to use as possible, letting you focus on creating and enjoying your prints instead of spending time tweaking and troubleshooting the machine. The printer features a bright OLED (organic light-emitting diode) screen which allows you to print files directly from an SD card, freeing up your computer to do other things. The glass-heated print bed accommodates ABS plastic printing (in addition to PLA filament) and the redesigned hot-end was designed with a smaller hot zone to reduce potential clogs and jams.Capable of printing from 30-300mm/s and up to a .02mm (20 micron) layer height, the Ultimaker 2 is the fastest, highest resolution FDM (fused-deposition modeling) printer on the market today.",
  //   features: [
  //     "minimum order quantity: 1 unit",
  //     "input format: g code",
  //     "operation mode: semi automatic",
  //     "size: 1.74mm",
  //   ],
  //   info: [
  //     "overall dimension: 338 x 358 x 389 mm",
  //     "build volume: 230 x 225 x 205 mm",
  //     "print speed: 30-300mm/",
  //     "maximum resolution: 0.02mm (20 micron)",
  //     "print from SD Card: yes",
  //     "print material: 3mm ABS or PLA",
  //     "noise level: 49db",
  //     "recommended software: cura",
  //   ],
  // },
  {
    id: 6,
    name: "GlobalSat BU-353S4 USB Aadhar GPS Receiver",
    websitType: "gps",
    image01: at2,
    description: "",
    features: [
      "minimum order quantity: 50 pcs",
      "model number: g star",
      "mobile access: no",
    ],
  },
  {
    id: 7,
    name: "Wetrack2 Tracking System",
    websitType: "gps",
    image01: wetrack1,

    features: [
      "minimum order quantity: 50 pcs",
      "access: mobile access",
      "usage: car, bike, truck,auto",
      "service: GSM Service",
      "vehicle type: any",
      "model number: wetrack2",
      "touch screen: no",
      "network type: any",
      "condition: new",
      "brand: concox",
      "network type: any",
      "type: wired",
    ],
  },
  {
    id: 8,
    name: "Garmin GPSMAP 64S",
    websitType: "gps",
    image01: wetrack2,
    description:
      "Built-in worldwide base map: With shaded relief, along with a 1-year subscription to BirdsEye Satellite Imagery, allows you to navigate with ease. Photo navigation lets you download geotagged pictures from the Internet and then navigate to them. Quad-helix antenna: Tracks both GPS and GLONASS satellites simultaneously to quickly locate your position and maintain your location, even in heavy cover and deep canyons. 2.6 transflective TFT color screen With 160 x 240 pixels showcases information in easy-to-read detail even in direct sunlight. The water-resistant design withstands moisture damage. Bluetooth and ANT+ technologies Let you wirelessly share waypoints, tracks, routes and geocaches to other enabled devices, including select Garmin handheld GPS units. 4GB internal memory Offers generous storage space. The microSD card slot enables you to download additional topographic, marine and road maps for simple system expansion.",
  },
  {
    id: 9,
    name: "Handheld Garmin GPS",
    websitType: "gps",
    image01: wetrack3,
    description:
      "We are assisted by our truly skilled and seasoned professionals in trading and supplying a precision-engineered range of GPS Navigation Device. Offered device is precisely assembled by our vendors’ experts using supreme quality components and ultra-modern technology. Improving the effectiveness of any system in place is met with time synchronization system deployed in the field, provided device is tested against different quality measures in order to ensure the quality. Apart from this, our precious clients can avail this device from us at affordable prices.",
    features: [
      "brand: garmin",
      "type: wireless",
      "screen size: 2.5inch",
      "mobile access: no",
      "easy aplication",
      "rugged design",
      "Improved print quality",
    ],
  },
  {
    id: 10,
    name: "Handheld GPS Device",
    websitType: "gps",
    image01: wetrack4,
    description:
      "To retain our goodwill in clients' consideration, we trade and supply a quality approved Handheld GPS Device. Our offered device is precisely manufactured at vendors’ end employing advanced technology and quality tested components. Time synchronization creates a platform for an entire system comprising wide range of products to operate in synchronous with time. Besides, we deliver this device from our end after testing it against different parameters. Our valuable clients can avail this device from us in various designs at industry leading prices.",
    features: [
      "type: wireless",
      "screen size: 2.5inch",
      "mobile access: no",
      "optimum functionality",
      "easy installation",
      "required less maintenance",
    ],
  },
  {
    id: 11,
    name: "GT800 Vehicle Tracker",
    websitType: "gps",
    image01: gt1,
    description:
      "GT800 With AC and ignition cut off. We are among the leading organization of the industry, involved in trading and supplying a superior quality assortment of GPS System. Our offered range of products consists of GPS Vehicle Tracking Devices, Vehicle Tracking Devices, and Calculating Area Device. Along with this, we are also offering Mobile App Development Services to our clients.",
    features: [
      "origin: made in india",
      "warranty: 1 year",
      "mobile access: yes",
      "tracking method: specilized software",
      "usage: car",
    ],
  },
  {
    id: 12,
    name: "Child GPS Personal Tracker GT300",
    type: "gps",
    websitType: "wireless",
    image01: gt2,
    description:
      "Smart data acquisiition(based on time,distance, angle, ignition and events, Sending acquired data via GPRS TCP/IP and UDP/IP protocols. Smart algorithm of GPRS connectionsGPRS traffic saving Operating in roaming networks preferred GSM providers list",
    features: [
      "Phone call available – 2 family numbers supported",
      "GSM 850/900/1800/1900 MHZ Quad-band •Accurate dual-location by GPS and LBS •SOS emergency alarm",
      "Large capacity internal battery for 98 hours working time",
      "Geo-fence alarming function",
      "suitable for cargo, container and personal tracking",
      "Built-in accelerating sensor for alarm function",
      "Web-based online tracking platform Specification",
      "Color: White and Blue",
      "Backup Battery: 1200mAH",
      "Standby Time: 98 hours",
      "Talk time: 7 hours",
      "GSM Frequencies: Quad-band",
      "GPRS: Class12",
      "GPS channel: 20",
      "GPS sensitivity: -159 dBM",
      "Position sensitivity: -144 dBM",
      "GSM/GPS antenna: Built-in Design",
      "Data transmit: TCP,SMS",
      "Geo- fence: view any existing Geo- fence in the map",
      "Overspeed Alarm: Alarm when over the pre-set speed",
      "Low Power Alarm: Alarm when backup battery is running out",
      "Non-movement Detection: Movement alarm based on built-in 3D motion sensor",
      "Mileage Report: Track by time/distance interval",
      "Internal Memory: 64mb 32mb •Communication Mode: GSM",
    ],
  },
  {
    id: 13,
    name: "Teltonika FMB202 Waterproof GPS",
    websitType: "teltonika",
    image01: tel1,
    features: [
      "Brand: teltonika",
      "model number: FMB202",
      "warranty: 1 year",
      "Hermetic enclose IP67",
      "Internal GSM antenna",
      "Internal GPS antenna",
      "GPS and I/O data acquisition",
      "real time tracking",
      "Smart data acquisiition(based on time,distance, angle, ignition and events)",
      "Sending acquired data via GPRS( TCP/IP and UDP/IP protocols)",
      "Smart algorithm of GPRS connections(GPRS traffic saving)",
      "Operating in roaming networks (preferred GSM providers list)",
      "Events on I/O detection and sending via GPRS or SMS.",
      "Scheduled 24 coordinates SMS sending",
      "5 geofence zones (rectangular or circle)",
      "Deep Sleep mode (less power consumption",
      "FOTA (firmware updating via GPRS)",
      "Motion sensor",
      "Small and easy to mount case",
      "3 operational modes (Home, Roaming, Unknow) based on operator",
      "Operation mode presets:",
      "Advanced overspeeding detection",
      "Driver identification (1-Wire® iButton ID key)",
      "GSM: Quad-band 900/1800 MHz; 850/1900 MHz",
      "GPRS class 10 (up to 85,6 kbps)",
      "SMS (text/data)",
    ],
  },
  {
    id: 14,
    name: "Teltonika FMC130",
    websitType: "teltonika",
    image01: tel2,
    description:
      "FMC130 is small and professional real-time tracking terminal with GNSS and LTE/3G/GSM connectivity and backup battery. Device equipped with GNSS/Bluetooth and LTE modules, internal GNSS, LTE antennas, configurable digital, analogue inputs and digital outputs, negative input, impulse inputs. It is perfectly suitable for applications where location acquirement of remote objects is needed: fleet management, car rental companies, taxi companies, public transport, logistics companies, personal cars and so on. ",
    features: [
      "origin: india",
      "operating humidity: 5% to 95% non-condensing",
      "Size/Dimension: 65 x 56,6 x 20,6 mm (L x W x H)",
      "Tracking Sensitivity: 165 dBM",
      "weight: 55g",
      "Operating Temp.:	-40 DegreeC to +85 DegreeC",
      "Memory: 128MB internal flash memory",
      "voltage: 10 - 30 V DC with overvoltage protection",
      "usage: truck",
    ],
  },
  {
    id: 15,
    name: "Teltonika FMU130",
    websitType: "teltonika",
    image01: tel3,
    description:
      "FMU130 is small and professional real-time tracking terminal with GNSS and 3G/GSM connectivity and backup battery. Device equipped with GNSS/Bluetooth and 3G modules, internal GNSS, 3G antennas, configurable digital, analogue inputs and digital outputs, negative input, impulse inputs. It is perfectly suitable for applications where location acquirement of remote objects is needed: fleet management, car rental companies, taxi companies, public transport, logistics companies, personal cars and so on.",
    features: [
      "origin: india",
      "operating humidity: 5% to 95% non-condensing",
      "Size/Dimension: 65 x 56.6 x 20.6 mm (L x W x H)",
      "Tracking Sensitivity: -165 dBM",
      "weight: 55g",
      "Operating Temp.:	40 DegreeC to +85 DegreeC",
      "Memory: 128MB internal flash memory",
      "voltage: 10 - 30 V DC with overvoltage protection",
      "usage: truck",
    ],
  },
  {
    id: 16,
    name: "Teltonika Fmu 125",
    websitType: "teltonika",
    image01: tel4,
    description:
      "FMU125 is small and professional real-time tracking terminal with GNSS and 3G/GSM connectivity and backup battery. Device equipped with GNSS/Bluetooth and 3G modules, internal GNSS, 3G antennas. FMU125 features RS485/RS232 data interface, which gives ability to connect various third-party external devices. It is perfectly suitable for applications where location acquirement of remote objects is needed: fleet management, car rental companies, taxi companies, public transport, logistics companies, personal cars and so on.",
    features: [
      "minimum order quantity: 10pcs",
      "origin: india",
      "operating humidity: 5% to 95% non-condensing",
      "antenna: GNSS antenna, Cellular antenna",
      "Size/Dimension: 65 x 56.6 x 20.6 mm (L x W x H)",
      "Tracking Sensitivity: -165 dBM",
      "weight: 55g",
      "Operating Temp.:	40 DegreeC to +85 DegreeC",
      "Memory: 128MB internal flash memory",
      "voltage: 10 - 30 V DC with overvoltage protection",
      "usage: truck",
    ],
  },
  {
    id: 17,
    name: "Teltonika Fmc 125",
    websitType: "teltonika",
    image01: tel5,
    description:
      "FMC125 is small and professional real-time tracking terminal with GNSS and LTE/3G/GSM connectivity and backup battery. Device equipped with GNSS/Bluetooth and LTE modules, internal GNSS, LTE antennas. FMC125 features RS485/RS232 data interface, which gives ability to connect various third-party external devices. It is perfectly suitable for applications where location acquirement of remote objects is needed: fleet management, car rental companies, taxi companies, public transport, logistics companies, personal cars and so on.",
    features: [
      "origin: india",
      "operating humidity: 5% to 95% non-condensing",
      "Size/Dimension: 65 x 56.6 x 20.6 mm (L x W x H)",
      "Tracking Sensitivity: -165 dBM",
      "weight: 55g",
      "Operating Temp.:	40 DegreeC to +85 DegreeC",
      "Memory: 128MB internal flash memory",
      "voltage: 10 - 30 V DC with overvoltage protection",
      "usage: truck",
    ],
  },
  {
    id: 18,
    name: "FMB204 IP67 GPS Tracking Device",
    websitType: "teltonika",
    image01: tel6,
    description:
      "Small and professional waterproof tracker with internal high gain GNSS/GSM antenas, Bluetooth and high capacity internal Li-ion battery Teltonika FMB204 is a SPECIAL waterproof (IP67) tracker with Bluetooth connectivity, internal high gain GNSS and GSM antennas and integrated high capacity backup battery. Device is designed to work longer without power supply. FMB204 with LiPo battery can work up to 6 days in power saving mode. FMB204 is perfectly suitable for agriculture, delivery, refrigerated transport, trailers tracking, security & emergency services and even more. 6-30V power supply makes FMB204 suitable for motorbikes and water transport. Smart Crash detection Ensure safety of Your employee with smart Crash detection. Get alarm message immediately after accident, save workers life! Waterproof (IP67) case IP67 protection class means that device is waterproof and 100% protected against solid objects like dust or sand. Such casing allows you to mount tracker to water transport, motorcycle or other transport with trust. BluetoothIntegrated Bluetooth 4.0 LE allows usage of  various wireless sensors and  grants compatibility with previously available Bluetooth V3.0 features like device configuration, firmware update, headset support. Retrieve temperature and humidity information from Bluetooth sensors without the need of wired connection – reduce installation costs. Save on fuel by reducing aggressive driving, increase your driver safety and reduce the number of driving-related incidents with Android application BTAPP.Integrated battery: High capacity internal Li-ion battery ensures long autonomous working hours, receive tracking data and warnings when main power source is disconnected.",
    features: [
      "minimum order quantity: 50 pcs",
      "usage: car, truck",
      "material: plastic",
      "Tracking technique: mobile app",
    ],
  },
  // {
  //   id: 19,
  //   name: "Teltonika FMB640 GPS Tracking Device",
  //   websitType: "teltonika",
  //   image01: tel7,
  //   description:
  //     "Teltonika FMB640 is GNSS, GSM and Blue-tooth terminal for PROFESSIONAL applications. FMB640 is designed for complex solutions, where one device can do multiple tasks. FMB640 features like FMS CAN data (J1939), fuel CAN data (J1708), tachograph live data (K-Line), remote tachograph file download, various third party RS232 or RS485 devices support and Dual-SIM will maximize your fleet efficiency.Terminal is suitable for applications like international logistics, refrigerated transport, agriculture, construction & mining, security & emergency services and even more. RS232/RS485 – data from external devices – fulfill customer special needs Tacho data and DDD files – remote access to tacho data – saves time and expenses FMS/LV-CAN/ALL-CAN – CAN data from various transport – expand value for customer  Dual SIM Double GSM network reliability with Dual SIM! Even if your main SIM card fails to connect, FMB640 will stay online. Moreover, Dual SIM significantly reduces roaming costs, when using first SIM card for Home, second for Roaming data networks. Bluetooth Integrated Blue-tooth 4.0 LE allows usage of various wireless sensors and grants compatibility with previously available Blue-tooth V3.0 features like device configuration, firmware update, headset support. Retrieve temperature and humidity information from Blue-tooth sensors without the need of wired connection – reduce installation costs. Make phone calls to your employee via Blue-tooth headset – be sure that your employee is always safe and uses hands free headset instead of phone! Integrated tachograph solution Integrated tachograph solution enables remote tachograph file (DDD, V1B, C1B or TGD format) download and live tachograph info acquisition without any additional adapter. Easier than ever connection – less integration time.RS232/RS485 RS232/RS485 functionality enables connection of third party devices like: multiple LLS sensors, GARMIN personal navigation device, RFID readers or some other RS232/RS48.",
  //   features: [
  //     "minimum order quantity: 50 pcs",
  //     "warranty: 2yrs",
  //     "usage: car, truck",
  //     "mobile access: yes",
  //   ],
  // },
  {
    id: 20,
    name: "Teltonika FMB120 GPS Tracking Device",
    type: "teltonika",
    websitType: "wired",
    image01: tel8,
    description:
      "We are a well-recognized name that is affianced in offering our valuable clients an effective quality GPS Vehicle Tracking Devices. In sync with industry standards, offered tracking devices are manufactured utilizing high grade components and innovative technology by our vendors’ professionals. Start working automatically after electrifying, tracking via SMS and GPRS, these tracking devices are checked against different quality measures so as to ensure their quality. Keeping in mind varied requirements of our clients, we offer these tracking devices in different technical specifications. Features: •Easy to operate •Less power consumption •Long service life Other Details: •Small and easy to mount case • Internal GSM antenna and Internal GPS/GLONASS antenna allow mount FM1120 much easier • Real Time tracking • Smart data acquisition – based on time, distance, angle, ignition and I/O events allow to have precise online • tracker • Sending acquired data via GPRS (TCP/IP and UDP/IP protocols) • Smart algorithm of GPRS connections for GPRS traffic saving • Operating in roaming networks by preferred GSM providers list • Events from I/O elements detection and sending via GPRS or SMS • Scheduled 24 coordinates SMS sending when GPRS not available • 5 geofence zones (rectangular or circle) • Auto Geofencing crested for car towing detection and car theft prevention • Deep Sleep mode (less than 2 mA power consumption) • FOTA (firmware updating via GPRS) • 3 operational modes (Home, Roaming, Unknown) based on operator Specifications: GSM: •Quad-band 900/1800 MHz; 850/1900 MHz • GPRS class 10 (up to 85,6 kbps) • SMS (text/data) GPS/Glonass: •NMEA protocol compatible.Messages: GGA, GGL, GSA, GSV, RMC, VTG, TXT • 32 channel GPS/GLONASS receiver • Not less than-160 dBm Interface: •1 Digital Input Reserved for ignition Status Monitoring • 2 Digital Input • 1 Analog input(10V or 30V range) • 2 Digital Open-collector Outputs(connecting external relays, LED, buzzers etc.) • 1 Wire® temperature sensor • 1 wire® iButton • Motion sensor • Power supply( 10… 30) V DC • internal GSM antenna • internal GPS/GLONASS antenna • integrated back-up battery • Dimensions: L(65mm)*W(56,6mm)*H(18,9mm) • 2 Status LEDs • Configuration and firmware upload(FOTA and via cable) •Teltonika FM 1120",
    features: [
      "minimum order quantity: 25 pcs",
      "gsp enabled: yes",
      "usb support: yes",
      "gsm service: yes",
      "backup battery: yes",
      "model number: FMB120",
      "battery power: yes",
      "warranty: 1 yr",
      "usage: car, truck",
      "mobile access: yes",
    ],
  },
  {
    id: 21,
    name: "Teltonika FMB640 GNSS, GSM, Bluetooth, RS232/RS485, CAN J1",
    websitType: "teltonika",
    image01: tel9,
    description:
      "2x SIM Card (Dual-SIM)K-Line Micro SDRS485CAN J1708 Firmware Profiles Transparent mode (RS232)DDD download and Tacho online data ALL-CAN support LV-CAN support Description  Product features  Technical details Dual SIM. Double GSM network reliability with Dual SIM! Even if your main SIM card fails to connect, FMB630 will stay online. Moreover, Dual SIM significantly reduces roaming costs, when using first SIM card for Home, second for Roaming data networks. Bluetooth Read records and configure your tracker wireless via Bluetooth No inconvenient configuration via SMS or searching for tracker in hard to reach places to connect USB cable. Single push and your device is connected to configuration via Bluetooth. Micro SD card. Don’t lose any records with micro SD card up to 32 GB! FMB630 will store all data in micro SD card when driving in areas where GSM is not available. Integrated tachograph solution. Integrated tachograph solution enables remote tachograph file (DDD, V1B, C1B or TGD format) download and live tachograph info acquisition without any additional adapter. Easier than ever connection – less integration time. RS232/RS485. RS232/RS485 functionality enables connection of third party devices like: multiple LLS sensors, GARMIN personal navigation device, RFID readers or some other RS232/RS485 devices.",
    features: [
      "minimum order quantity: 10 pcs",
      "warranty: 1 yr",
      "usage: car, truck, bus",
      "mobile access: yes",
    ],
  },
  {
    id: 22,
    name: "Teltonika FMB920 GPS Tracking System",
    websitType: "teltonika",
    image01: tel10,
    description: "",
    features: [
      "minimum order quantity: 50 pcs",
      "gsp enabled: yes",
      "usb support: yes",
      "avaiable accessories: wire",
      "bluetooth: yes",
      "installation required: yes",
      "color: black",
      "model number: FMB920",
      "gsm service: yes",
      "touch screen: no",
      "GPRS: yes",
      "backup battery: yes",
      "model number: FMB120",
      "warranty: 1 yr",
      "mobile access: yes",
    ],
  },
  {
    id: 23,
    name: "Teltonika FMB010 OBD Devices",
    websitType: "teltonika",
    image01: tel11,
    description:
      "Smart data acquisiition(based on time,distance, angle, ignition and events, Sending acquired data via GPRS TCP/IP and UDP/IP protocols. Smart algorithm of GPRS connectionsGPRS traffic saving Operating in roaming networks preferred GSM providers list",
  },
  {
    id: 24,
    name: "Teltonika FMB910 Bluetooth v3.0",
    websitType: "teltonika",
    image01: tel12,
    description:
      "Smart data acquisiition(based on time,distance, angle, ignition and events, Sending acquired data via GPRS TCP/IP and UDP/IP protocols. Smart algorithm of GPRS connectionsGPRS traffic saving Operating in roaming networks preferred GSM providers list",
  },
  {
    id: 25,
    name: "Teltonika FMB125 GPS",
    websitType: "teltonika",
    image01: tel13,
    description:
      "Smart data acquisiition(based on time,distance, angle, ignition and events, Sending acquired data via GPRS TCP/IP and UDP/IP protocols. Smart algorithm of GPRS connectionsGPRS traffic saving Operating in roaming networks preferred GSM providers list",
    features: ["services are defined"],
  },
  {
    id: 26,
    name: "FMB001 OBD-II GPS Tracker",
    websitType: "teltonika",
    image01: tel14,
    description:
      "Smart data acquisiition(based on time,distance, angle, ignition and events, Sending acquired data via GPRS TCP/IP and UDP/IP protocols. Smart algorithm of GPRS connectionsGPRS traffic saving Operating in roaming networks preferred GSM providers list",
  },
  {
    id: 27,
    name: "V5 Concox GPS Tracker",
    websitType: "gps",
    image01: v5concox,
    description:
      "With the years of understanding in this particular realm, we are engaged in presenting a premium array Vehicle GPS Devices. The provided range is developed by professionals with use of exceptional quality components and pioneering technology.",
    features: [
      "Screen Size: 3.5 inch",
      "Mobile Access: Yes",
      "Usage: Truck,Auto,Car,Bike",
      "Type: Wired",
    ],
    info: [
      "GSM Quad-band",
      "GPS GSM GPRS wireless network",
      "High sensitive GPS chipset",
      "Real-time tracking",
      "Built-in GSM&GPS antenna",
      "Built-in ON/OFF power, wide voltage input range",
      "Built-in acceleration sensor for vibration alarm",
      "Support ACC detection, real-time reporting car status",
      "Built-in 450mAh battery for alarm when the power supply is disconnected unexpectedly",
      "Tele-cut off (petrol/electricity) function",
      "Certifications: e-mark, CE",
    ],
  },
  {
    id: 28,
    name: "V5 Concox GPS Tracker",
    websitType: "gps",
    image01: v5concox,
    description:
      "With the years of understanding in this particular realm, we are engaged in presenting a premium array Vehicle GPS Devices. The provided range is developed by professionals with use of exceptional quality components and pioneering technology.",
    features: [
      "Screen Size: 3.5 inch",
      "Mobile Access: Yes",
      "Usage: Truck,Auto,Car,Bike",
      "Type: Wired",
    ],
    info: [
      "GSM Quad-band",
      "GPS GSM GPRS wireless network",
      "High sensitive GPS chipset",
      "Real-time tracking",
      "Built-in GSM&GPS antenna",
      "Built-in ON/OFF power, wide voltage input range",
      "Built-in acceleration sensor for vibration alarm",
      "Support ACC detection, real-time reporting car status",
      "Built-in 450mAh battery for alarm when the power supply is disconnected unexpectedly",
      "Tele-cut off (petrol/electricity) function",
      "Certifications: e-mark, CE",
    ],
  },
];
